import { useQuery } from 'react-query';
import { get, post } from 'axios';

const passwordUrl = 'xm/free/api/password';

export function useGetPasswordPolicy() {
  return useQuery(
    'passwordPolicy',
    () => get(`${passwordUrl}/policy`).then(({ data }) => data),
    {
      refetchOnMount: 'always',
    },
  );
}

export function useValidatePassword(password, config = {}) {
  return useQuery(
    'validatePassword',
    () =>
      post(`${passwordUrl}/validate`, { password }).then(({ data }) => data),
    config,
  );
}
